/**
 * Подсказка следующего шага поверх карты (§24.3).
 *
 * Назначение файла: одна строка, отвечающая на вопрос «что сейчас». Шаг считает
 * game/onboarding.ts, здесь только показ и закрытие.
 */

import { useTranslation } from "react-i18next";

import { stepMessageKey, type OnboardingStep } from "../game/onboarding.js";

export interface HintBarProps {
  readonly step: Exclude<OnboardingStep, null>;
  readonly onDismiss: () => void;
}

export function HintBar({ step, onDismiss }: HintBarProps): React.JSX.Element {
  const { t } = useTranslation(["onboarding", "common"]);

  return (
    <div className="hint-bar" role="status">
      <span className="hint-bar__mark" aria-hidden="true">
        <svg viewBox="0 0 24 24" width="16" height="16">
          <path
            d="M12 3.2 19 7.1v7.8L12 18.8 5 14.9V7.1z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinejoin="round"
          />
          <path d="M12 9v4M12 15.4h.01" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      </span>
      <p className="hint-bar__text">
        <span className="hint-bar__title">{t("onboarding:hint.title")}</span>
        {t(stepMessageKey(step))}
      </p>
      <button
        type="button"
        className="hint-bar__dismiss"
        onClick={onDismiss}
        title={t("onboarding:hint.hide")}
        aria-label={t("onboarding:hint.hide")}
      >
        <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
          <path
            d="M6 6l12 12M18 6L6 18"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
          />
        </svg>
      </button>
    </div>
  );
}
